import { render } from "./addStudent.vue?vue&type=template&id=3827e6fa"
import script from "./addStudent.vue?vue&type=script&lang=js"
export * from "./addStudent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__